angular.module('webremote.settings').controller('webremote.settings.log.controller', function ($scope) {

})
